import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getTransactionSaleSummary, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportTransactionSalesSummaryCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class TransactionSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `TransactionSalesSummaryBeginDate`);
        this.props.formInput(date, `TransactionSalesSummaryEndDate`);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/transactionsummary?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}`, "Transactionsummary");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getTransactionSalesSummary({ beginDate, endDate, pageNumber, pageSize, branch });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.transactionSalesSummary && newProps.transactionSalesSummary.list && newProps.transactionSalesSummary.list.length > 0 ? newProps.transactionSalesSummary.list[0].totalRows : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {

        return (
            <Grid headerContent={reportTransactionSalesSummaryCrumb}>
                <div className="bg-light-opacity">
                    <div className="row m-0 pa-2">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="d-flex a-items">
                                <h2>{LOOKUP.report.transactionSummary.text}</h2>
                                <KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-transaction-count-summary-report" />
                            </div>
                            <h5>{LOOKUP.report.transactionSummary.description}</h5>
                        </div>
                    </div>
                    <div className="pa-2">
                        <Header
                            branchOptions={this.props.brachOptions}
                            filter={this.filter}
                            download={this.downloadReport}
                            showBody={this.showBody}
                            loggedBranch={this.props.loggedBranch}
                        />
                        {
                            this.state.showBody &&
                            <p className="text-right mt-2 blue-text">
                                <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                            </p>
                        }
                    </div>
                </div>
                <div id="patient-list-table">
                    {
                        this.state.showBody &&
                        <CardSimple>
                            <Body
                                transactionSalesSummary={this.props.transactionSalesSummary}
                                beginDate={this.props.beginDate}
                                endDate={this.props.endDate}
                                loggedBranch={this.props.loggedBranch}
                                branchForm={this.props.branch}
                            />
                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        transactionSalesSummary: state.reports.transactionSalesSummary || [],
        loggedBranch: state.common.branchId,
        beginDate: state.form.TransactionSalesSummaryBeginDate,
        endDate: state.form.TransactionSalesSummaryEndDate,
        branch: state.form.TransactionSalesSummaryBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getTransactionSalesSummary: model => dispatch(getTransactionSaleSummary(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(TransactionSummary));